import Link from 'next/link';
import Image from 'next/image';
import { BlogPost } from '@/lib/blog';
import { Locale, getLocalePath } from '@/lib/i18n';
import { formatBlogDate } from '@/lib/blog';
import styles from './BlogCard.module.css';

interface BlogCardProps {
  post: BlogPost;
  locale: Locale;
  readTimeLabel: string;
}

export function BlogCard({ post, locale, readTimeLabel }: BlogCardProps) {
  const { metadata, content, readTime } = post;
  const postUrl = getLocalePath(locale, `/blog/${metadata.slug}`);

  return (
    <Link href={postUrl} className={styles.card}>
      <article className={styles.article}>
        <div className={styles.imageWrapper}>
          <Image
            src={metadata.image}
            alt={content.title}
            fill
            sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
            className={styles.image}
            loading="lazy"
          />
        </div>
        
        <div className={styles.content}>
          <div className={styles.meta}>
            <time dateTime={metadata.publishedDate} className={styles.date}>
              {formatBlogDate(metadata.publishedDate, locale)}
            </time>
            <span className={styles.separator}>•</span>
            <span className={styles.readTime}>
              {readTime} {readTimeLabel}
            </span>
          </div>

          <h2 className={styles.title}>{content.title}</h2>
          
          <p className={styles.excerpt}>{content.excerpt}</p>

          <div className={styles.tags}>
            {metadata.tags.map((tag) => (
              <span key={tag} className={styles.tag}>
                <span>{tag}</span>
              </span>
            ))}
          </div>
        </div>
      </article>
    </Link>
  );
}

